import { z } from 'zod'

export const RailPassengerIdZ = z.string().brand<'RailPassengerId'>()

export type RailPassengerId = z.infer<typeof RailPassengerIdZ>

export const RailPassengerPricePointIdZ = z.string().brand<'RailPassengerPricePointId'>()

export type RailPassengerPricePointId = z.infer<typeof RailPassengerPricePointIdZ>

/** Example: outward-TGV32953-wagon3-deck1-seat68-id */
export const RailSeatIdZ = z.string().brand<'RailSeatId'>()

export type RailSeatId = z.infer<typeof RailSeatIdZ>

export const RailSectionIdZ = z.string().brand<'RailSectionIdZ'>()

export type RailSectionId = z.infer<typeof RailSectionIdZ>

export const RailLegIdZ = z.string()

export type RailLegId = z.infer<typeof RailLegIdZ>

export const RailReservationOfferIdZ = z.string().brand<'RailReservationOfferId'>()

export type RailReservationOfferId = z.infer<typeof RailReservationOfferIdZ>

export const RailSeatPreferenceGroupIdZ = z.string().brand<'RailSeatPreferenceGroupId'>()

export type RailSeatPreferenceGroupId = z.infer<typeof RailSeatPreferenceGroupIdZ>

export const RailDirectionZ = z.enum([
	'one_way',
	'open_return', // Similar to `round_trip`, but the return slice in not selected, but paid for
	'round_trip',
	'seat_only', // Similar to `one_way`, but the the user selects the seat price instead of the fare
])

export const RailDirection = RailDirectionZ.enum

export type RailDirection = z.infer<typeof RailDirectionZ>

// eslint-disable-next-line no-restricted-syntax
export enum RailTransportType {
	Train = 'train',
	LocalTrain = 'Local train',
	Bus = 'bus',
	Ferry = 'ferry',
}

export const RailTransportTypeZ = z.enum(RailTransportType)

export const RailVendorZ = z.enum(['DB_BIBE', 'DB', 'SNCF', 'ATOC', 'OTHER', 'EUROSTAR'])

export const RailVendor = RailVendorZ.enum

export type RailVendor = z.infer<typeof RailVendorZ>

export const RailProviderNameZ = z.enum(['deutschebahn', 'sncf'])

export const RailProviderName = RailProviderNameZ.enum

export type RailProviderName = z.infer<typeof RailProviderNameZ>

export const RailProviderLabelZ = z.enum(['Deutsche Bahn', 'UK Rail'])

export type RailProviderLabel = z.infer<typeof RailProviderLabelZ>

export const RailProviderLabel = RailProviderLabelZ.enum

export const RailProviderCountryZ = z.enum(['UK', 'DE'])

export const RailProviderType = RailProviderCountryZ.enum

export type RailProviderValues = z.infer<typeof RailProviderCountryZ>

// TODO: Remove old train fields and add branded id
/** {@link useNewRailSearchToggle} */

// export const RailDiscountCardIdZ = z.string().brand<'RailDiscountCardIdZ'>()

// export const RailDiscountCardZ = z.strictObject({
// 	card_id: RailDiscountCardIdZ,
// 	name_en: z.string(),
// 	vendor: z.string().optional(),
// 	active: z.boolean().optional(),
// })

export const RailDiscountCardZ = z.strictObject({
	id: z.string(),
	card_id: z.string().nullish(),
	vendor_code: z.string().nullable(),
	name_en: z.string(),
	vendor: RailVendorZ.optional(),
	status: z.string().optional(),
})

export type RailDiscountCard = z.infer<typeof RailDiscountCardZ>

export const RailPassengerTypeZ = z.object({
	age_restriction: z
		.strictObject({ lower_bound: z.number().nullable(), upper_bound: z.number().nullable() })
		.refine((data) => data.lower_bound || data.upper_bound),
	name: z.string(),
	id: z.string(),
	is_age_required: z.boolean(),
	is_default: z.boolean(),
})

export type RailPassengerType = z.infer<typeof RailPassengerTypeZ>

export const IncludedExtrasZ = z.array(
	z.strictObject({
		id: z.string(),
		leg_ids: z.array(z.string()),
		passenger_ids: z.array(z.string()),
		extra_type: z.object({
			name: z.string(),
			group: z.string(),
			localizations: z.array(z.unknown()),
		}),
	}),
)
export type IncludedExtras = z.infer<typeof IncludedExtrasZ>

export interface TrainDiscountCard {
	id: string
	name_en: string
	status: string
	vendor?: RailVendor
	vendor_code: string | null
	card_id: string
	is_number_required: boolean
	number_length: number | null
	number_prefix: string | null
	number_validation_regex: string | null
	validation_algorithm: string | null
}

export interface UserRailCard {
	id?: string | null
	card_type_id?: string | null
	card_number?: string
	expiration_date?: string
	card_type?: Partial<TrainDiscountCard> | null
	card_type_name: string | null | undefined
	is_preferred: boolean
	provider?: RailVendor
}
